import { render, staticRenderFns } from "./myQuestions.vue?vue&type=template&id=4bb259d1&scoped=true"
import script from "./myQuestions.vue?vue&type=script&lang=js"
export * from "./myQuestions.vue?vue&type=script&lang=js"
import style0 from "./myQuestions.vue?vue&type=style&index=0&id=4bb259d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb259d1",
  null
  
)

export default component.exports